<template>
  <div>
    <b-form-checkbox-group
              v-model="checkList"
              :class="{'is-invalid' : error}"
              :name="`formData[${currentField.tagname}][]`"
              :options="currentField.options"
              text-field="optionLabel"
              value-field="optionValue"
            ></b-form-checkbox-group>
            <span class="invalid-feedback" role="alert" v-if="error">
                <strong>{{ error }}</strong>
            </span>
  </div>
</template>

<script>
import fetchData from '@/api/fetch-data';
export default {
  name: 'Checkbox',
  props: ['currentField', 'error', 'value'],
  data() {
    return {
      checkList: this.value ?? []
    }
  },

  watch: {
    value (value) {
      this.checkList = value ?? []
    },

    checkList(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  },

  mounted() {
    if (this.currentField.isFromFormList) {
      let dataUrl = '/lists/' + this.currentField.formListTag;
      let valueField = 'value';
      let labelField = 'label';
      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField);
      promise.then((data) => {
        // console.log(data)
        this.currentField.options = data;
      });
    }
  }
}
</script>

<style>
.el-checkbox-group {
  font-size: 14px;
}
</style>
